//LAST INCREMENTAL OMNICHANNEL OMN00153
//LAST INCREMENTAL KIOSK KIO00335
//LAST INCREMENTAL SETTINGS STG00032
//LAST INCREMENTAL PIM PIM00012

export const TranslationKeys = {
  //WEB PAGE TITLE
  titleDiWa: 'KIO00272',

  //COURTESY
  courtesyText: 'KIO00270',

  //PAGE HEADER
  headerTitle: 'KIO00024',

  //SIDE NAVIGATION
  diwa: 'KIO00292',
  omnichannel: 'KIO00293',
  settings: 'KIO00294',
  utility: 'KIO00330',

  /*KIOSK*/
  buttonPriceSection: 'KIO00279',
  buttonSituationSection: 'KIO00280',
  buttonAvailabilitySection: 'KIO00281',
  buttonMovementsSection: 'KIO00282',
  buttonQuantityLimitSection: 'KIO00291',
  buttonDescSection: 'STG00009',
  buttonPubbliSection: 'KIO00315',

  //LOGIN
  usernameLogin: 'KIO00298',
  passwordLogin: 'KIO00299',
  usernameRequired: 'KIO00300',
  passwordRequired: 'KIO00301',
  submitLogin: 'KIO00302',

  //ARTICLE TABLE
  //set as { table + variableValue }
  tableArticleCode: 'KIO00001',
  tableIdFarfetch: 'KIO00002',
  tableCategory: 'KIO00003',
  tableSuperCategory: 'KIO00303',
  tableBrand: 'KIO00004',
  tableSeason: 'KIO00005',
  tableDepartment: 'KIO00006',
  tableColor: 'KIO00007',
  tableSupplier: 'KIO00008',
  tableStorageLocation: 'KIO00009',
  tableProductDescription: 'KIO00010',
  tableFabric: 'KIO00011',
  tableSize: 'KIO00012',
  tablePattern: 'KIO00013',
  tableLifestyle: 'KIO00014',
  tableBarcode: 'KIO00015',
  tableCustomsCode: 'KIO00016',
  tableCountryOrigin: 'KIO00017',
  tableDetailedComposition: 'KIO00018',
  tableOriginalRetailPrice: 'KIO00019',
  tableRetailPrice: 'KIO00020',
  tableDiscountedPrice: 'KIO00021',
  tableWholesalePrice: 'KIO00022',
  tableGrossWholesalePrice: 'KIO00023',
  acronymTableAvailability: 'KIO00140',
  tableEmptyColumnsAutocomplete: 'KIO00163',
  tableDescriptionShort: 'KIO00168',
  tableDescriptionSpecial: 'KIO00169',
  tableDescription: 'KIO00170',
  tableSizeAndFit: 'KIO00171',
  tableSuperColor: 'KIO00174',
  tableSuperBrand: 'KIO00176',
  tableSubCategory: 'KIO00178', //check
  tableField1: 'KIO00258',
  tableField2: 'KIO00259',
  tableField3: 'KIO00260',
  tableField4: 'KIO00261',
  tableField5: 'KIO00262',
  tableField6: 'KIO00263',
  tableField7: 'KIO00264',
  tableField8: 'KIO00265',
  tableField9: 'KIO00266',
  tableField10: 'KIO00267',
  tableMktYes: 'KIO00180',
  tableMktNo: 'KIO00181',
  tableDiscountedPrice1: 'KIO00192',
  tableDiscountedPrice2: 'KIO00193',
  duplicatedPricelist: 'KIO00196',
  tableProductCode: 'KIO00246',
  tableCollectionType: 'KIO00253',
  tableEmptyTextAvailabilities: 'KIO00032',
  tableEmptyTextMovement: 'KIO00033',
  tableEmptyTextExistance: 'KIO00034',
  tableBarcodeRecapPopoverSize: 'KIO00256',
  tableBarcodeRecapPopoverBarcode: 'KIO00257',
  tablePriceListSizePopoverSize: 'KIO00295',
  tableTags: 'KIO00332',
  scattoTaglia: 'KIO00296',
  multipleSearchResultsLabel: 'KIO00311',

  //FILTER SETTINGS ARTICLE TABLE
  //set as { filter + variableValue }
  filtersTitle: 'KIO00025',
  filtersPrincipal: 'KIO00026',
  filtersPrices: 'KIO00027',
  filtersExtra: 'KIO00028',
  filtersOptional: 'KIO00029',
  tablePagination: 'KIO00030',
  sizeAndFit: 'KIO00035',
  filterField1: 'KIO00036',
  filterField2: 'KIO00037',
  filterField3: 'KIO00038',
  filterField4: 'KIO00039',
  filterField5: 'KIO00040',
  filterField6: 'KIO00041',
  filterField7: 'KIO00042',
  filterField8: 'KIO00043',
  filterField9: 'KIO00044',
  filterField10: 'KIO00045',
  pricelist1: 'KIO00057',
  pricelist2: 'KIO00058',
  emptyPricelist: 'KIO00059',
  maxTwoPrices: 'KIO00060',
  emptyFilterIncipit: 'KIO00107',
  filterArticleCode: 'KIO00117',
  filterIdFarfetch: 'KIO00118',
  filterCategory: 'KIO00119',
  filterSuperCategory: 'KIO00303',
  filterBrand: 'KIO00120',
  filterSeason: 'KIO00121',
  filterDepartment: 'KIO00122',
  filterColor: 'KIO00123',
  filterSupplier: 'KIO00124',
  filterStorageLocation: 'KIO00125',
  filterProductDescription: 'KIO00126',
  filterFabric: 'KIO00127',
  filterSize: 'KIO00128',
  filterPattern: 'KIO00129',
  filterLifestyle: 'KIO00130',
  filterBarcode: 'KIO00131',
  filterCustomsCode: 'KIO00132',
  filterCountryOrigin: 'KIO00133',
  filterDetailedComposition: 'KIO00134',
  filterOriginalRetailPrice: 'KIO00135',
  filterRetailPrice: 'KIO00136',
  filterDiscountedPrice: 'KIO00137',
  filterWholesalePrice: 'KIO00138',
  filterGrossWholesalePrice: 'KIO00139',
  filterDescriptionShort: 'KIO00164',
  filterDescriptionSpecial: 'KIO00165',
  filterDescription: 'KIO00166',
  filterSizeAndFit: 'KIO00167',
  filterWebAndMarketplace: 'KIO00172',
  filterSuperColor: 'KIO00173',
  filterSuperBrand: 'KIO00175',
  filterSubCategory: 'KIO00177',
  filterDiscountedPrice1: 'KIO00190',
  filterDiscountedPrice2: 'KIO00191',
  filterProductCode: 'KIO00245',
  filterCollectionType: 'KIO00254',
  filterTags: 'KIO00331',

  tagsValidation: 'KIO00333',
  tagsAlreadyInsert: 'KIO00334',

  //CONFIGURATION DROPDOWN HEAD
  configurationDropdownAction: 'KIO00046',
  configurationDropdownNotification: 'KIO00047',
  configurationDropdownPopYes: 'KIO00048',
  configurationDropdownPopNo: 'KIO00049',
  configurationDropdownPopDesc: 'KIO00050',
  configurationDropdownCreateModalTitle: 'KIO00051',
  configurationDropdownEditModalTitle: 'KIO00052',
  configurationDropdownModalInputPlaceholder: 'KIO00053',
  configurationDropdownCreateModalButton: 'KIO00054',
  configurationDropdownEditModalButton: 'KIO00055',
  configurationDropdownSaved: 'KIO00056',
  configurationValueNotProvided: 'KIO00116',
  configurationPopAlreadyCreateDescription: 'KIO00078',
  configurationCreateNewWorkspace: 'KIO00271',

  //DESCRIPTIONS TABS
  desctabClassifications: 'KIO00314',
  desctabDescriptions: 'STG00009',
  desctabImages: 'PIM00001',
  desctabPrices: 'KIO00027',
  desctabPublications: 'KIO00315',
  desctabSeo: 'KIO00316',
  desctabTag: 'KIO00317',
  desctabReports: 'KIO00318',
  desctabLog: 'KIO00319',
  checkerrors: 'KIO00321',
  ismandatory: 'KIO00322',
  copyfullset: 'KIO00323',
  copyselectedset: 'KIO00324',
  copyinallset: 'KIO00325',
  copyin: 'KIO00326',

  //QUANTITIES FILTER AND TABLE
  //filter set as { checkbox + variableValue }
  //table set as { quantities + variableValue }
  acronymAvailability: 'KIO00061',
  acronymExistingStock: 'KIO00062',
  checkboxAvailability: 'KIO00063',
  checkboxExistingStock: 'KIO00064',
  checkboxWithdrawn: 'KIO00065',
  checkboxOrdered: 'KIO00066',
  checkboxDelivered: 'KIO00067',
  checkboxPurchased: 'KIO00068',
  checkboxOnConsignement: 'KIO00069',
  checkboxSellout: 'KIO00070',
  checkboxUnfilled: 'KIO00071',
  checkboxReturnSupplier: 'KIO00072',
  checkboxReturnCustomer: 'KIO00073',
  checkboxHockB2B: 'KIO00074',
  checkboxHockB2C: 'KIO00075',
  checkboxTailorShop: 'KIO00076',
  checkboxTransit: 'KIO00077',
  checkboxEntries: 'KIO00185',
  checkboxExits: 'KIO00186',
  checkboxStockInitial: 'KIO00268',
  articleSwitchUncheck: 'KIO00079',
  lockedHandlingSwitchCheck: 'KIO00080',
  lockedHandlingSwitchUncheck: 'KIO00081',
  quantitiesInputHandleNumber: 'KIO00095',
  quantitiesCheckboxTitle: 'KIO00108',
  quantitiesSituationFilter: 'KIO00194',
  quantitiesHandledButtonLabel: 'KIO00214',
  quantitiesHeadStoreName: 'KIO00215',
  quantitiesHeadTotal: 'KIO00216',
  quantitiesLabelWithdrawn: 'KIO00217',
  quantitiesLabelOrdered: 'KIO00218',
  quantitiesLabelDelivered: 'KIO00219',
  quantitiesLabelPurchased: 'KIO00220',
  quantitiesLabelOnConsignement: 'KIO00221',
  quantitiesLabelSellout: 'KIO00222',
  quantitiesLabelUnfilled: 'KIO00223',
  quantitiesLabelReturnSupplier: 'KIO00224',
  quantitiesLabelReturnCustomer: 'KIO00225',
  quantitiesLabelHockB2B: 'KIO00226',
  quantitiesLabelHockB2C: 'KIO00227',
  quantitiesLabelTailorShop: 'KIO00228',
  quantitiesLabelTransit: 'KIO00229',
  quantitiesLabelEntries: 'KIO00187',
  quantitiesLabelExits: 'KIO00188',
  quantitiesLabelStockInitial: 'KIO00269',
  quantitiesHandledInputWarning: 'KIO00230',
  situationTableHeadLabel: 'KIO00241',
  checkboxSelectDeselectAllLabel: 'KIO00243',
  movementsQuantitiesSuccessMessage: 'KIO00251',
  movementsQuantitiesErrorMessage: 'KIO00252',
  tableNoResults: 'KIO00189',

  //IMAGE MODAL
  imageTypeAll: 'KIO00082',
  missingImgPath: 'KIO00085',
  notFoundImgPath: 'KIO00086',
  imageTypeMain: 'KIO00112',
  imageTypeDetail: 'KIO00113',
  imageTypeDraw: 'KIO00114',
  imageTypeMarketplace: 'KIO00115',

  //UPPER MENU SECTION
  filterSettingsTips: 'KIO00087',
  barcodeTips: 'KIO00088',
  clearFilterTips: 'KIO00089',
  stepBack: 'KIO00090',
  stepForward: 'KIO00091',
  storeTips: 'KIO00092',
  nearStoreTips: 'KIO00093',
  allStoreTips: 'KIO00094',
  enableEditTips: 'KIO00160',
  searchFilterDropdownAll: 'KIO00247',
  searchFilterDropdownMovements: 'KIO00248',
  searchFilterDropdownAvailabilities: 'KIO00249',
  searchFilterDropdownExistance: 'KIO00250',

  //BARCODE
  barcodeInputExtraErrorInfo: 'KIO00083',
  barcodeClientiError: 'KIO00096',
  barcodeMovimentiError: 'KIO00097',
  barcodeUtentiError: 'KIO00098',
  barcodeAddettiError: 'KIO00099',
  barcodeColliError: 'KIO00100',
  barcodeUbicazioniError: 'KIO00101',
  barcodeCellaGrigliaError: 'KIO00102',
  barcodeNegoziError: 'KIO00103',
  barcodeBoxError: 'KIO00104',

  barcodeSuperBoxError: 'KIO00105', //check
  barcodeArticoliKitError: 'KIO00106', //check
  barcodeGenericError: 'KIO00179',
  barcodeNotProvided: 'KIO00255',

  //FILTER TAG
  emptyColumnsTag: 'KIO00109',
  negateColumnsTag: 'KIO00110',
  filterTag: 'KIO00111',

  //EDIT ARTICLE TABLE AND DOTS MENU
  editModalTitle: 'KIO00141',
  editModalInputPlaceholder: 'KIO00142',
  editModalButtonText: 'KIO00143',
  tableDotsMenuSort: 'KIO00144',
  tableDotsMenuSetFilter: 'KIO00145',
  tableDotsMenuDefault: 'KIO00146',
  tableDotsMenuExceptFor: 'KIO00147',
  tableDotsMenuEmpty: 'KIO00148',
  tableDotsLockColumn: 'KIO00149',
  tableDotsMenuLockLeft: 'KIO00150',
  tableDotsMenuLockRight: 'KIO00151',
  tableDotsMenuUnlocked: 'KIO00152',
  tableDotsMenuAdaptColumn: 'KIO00153',
  tableDotsMenuAdaptAllColumns: 'KIO00154',
  tableDotsMenuResetFixedColumns: 'KIO00155',
  tableDotsMenuEditSelection: 'KIO00156',
  tableSelectionMenuSelectAll: 'KIO00157',
  tableSelectionMenuSelectCurrentPage: 'KIO00158',
  tableSelectionMenuInvertSelection: 'KIO00159',
  tableDotsMenuEditDisableTips: 'KIO00161',
  tableDotsMenuEditLockedTips: 'KIO00162',
  editResultFullSelect: 'KIO00242',
  tableDotsNewLine: 'KIO00244',
  editModalSpecialEditModelMessage: 'KIO00031',
  tableBarcodeEditError: 'KIO00195',
  tableDotsMenuMktAll: 'KIO00182',
  tableDotsMenuMktYes: 'KIO00183',
  tableDotsMenuMktNo: 'KIO00184',
  editModalTagAddButtonText: 'KIO00335',

  //FILTER MOVEMENTS AVAILABILITIES
  checkboxEnableMovementLog: 'KIO00197',

  //MOVEMENTS AVAILABILITIES TABLE
  marketplaceMissingWarning: 'KIO00084',
  tableAvailabilitiesStoreName: 'KIO00198',
  tableAvailabilitiesDate: 'KIO00199',
  tableAvailabilitiesDocumentationNumber: 'KIO00200',
  tableAvailabilitiesCausal: 'KIO00201',
  tableAvailabilitiesStatus: 'KIO00202',
  tableAvailabilitiesReference: 'KIO00203',
  tableAvailabilitiesQuantity: 'KIO00204',
  tableAvailabilitiesDotsMenuOrder: 'KIO00205',
  availabilitiesMovementsCheckLabel: 'KIO00206',
  availabilitiesAvailabilityCheckLabel: 'KIO00207',
  filterHandlingSize: 'KIO00208',
  filterHandlingMarketplace: 'KIO00209',
  filterHandlingZeroMovements: 'KIO00304',
  tableAvailabilitiesDotsMenuCausalSelection: 'KIO00210',
  tableAvailabilitiesDotsMenuAllCausal: 'KIO00211',
  tableAvailabilitiesDotsMenuAvailableCausal: 'KIO00212',
  tableAvailabilitiesDetails: 'KIO00213',
  tableAvailabilitiesUserDetail: 'KIO00231',
  tableAvailabilitiesSizes: 'KIO00232',
  tableAvailabilitiesDateStamp: 'KIO00233',
  availabilitiesDateFilterFrom: 'KIO00234',
  availabilitiesDateFilterTo: 'KIO00235',
  availabilitiesCheckboxTitle: 'KIO00236',
  tableAvailabilitiesProgressiveAvailability: 'KIO00237',

  //MARKETPLACE
  //table set as { quantities + variableName }
  marketplaceAvailabilitiesSectionLabel: 'KIO00238',
  tableMarketplaceCategory: 'KIO00239',
  tableMarketplaceEngaged: 'KIO00240',
  availabilitiesLimit: 'KIO00297',

  //PRICE SECTION
  priceSectionDropdownListingLabel: 'KIO00273',
  priceSectionDropdownListingAllValue: 'KIO00274',
  priceSectionTableDiscountLabel: 'KIO00275',
  priceSectionTablePriceLabel: 'KIO00276',
  priceSectionTableFilterACQLabel: 'KIO00277',
  priceSectionTableFilterVENLabel: 'KIO00278',
  priceSectionTableSaleLabel: 'KIO00283',
  priceSectionTablePromoLabel: 'KIO00284',
  priceSectionTitleOmnichannel: 'KIO00305',
  priceSectionTitleHistory: 'KIO00306',
  priceSectionTableFilterRangeMonth: 'KIO00307',
  priceSectionTableFilterRange3Months: 'KIO00308',
  priceSectionTableFilterRangeYear: 'KIO00309',
  priceSectionTableFilterRangeFreeDates: 'KIO00310',
  priceSectionTableOmnichannelNoRules: 'KIO00312',
  priceSectionTableFilterTAGLabel: 'KIO00313',
  priceSectionNoSalesDate: 'KIO00320',
  priceSectionTitleEdit: 'KIO00327',

  //QUANTITY LIMIT SECTION
  quantityLimitSizeColName: 'KIO00285',
  quantityLimitNetOrderedRowName: 'KIO00286',
  quantityLimitAvailableRowName: 'KIO00287',
  quantityLimitRestoreLimit: 'KIO00288',
  quantityLimitDelayDaysColName: 'KIO00289',
  quantityLimitDefaultSizeQuantityColName: 'KIO00290',

  /*OMNICHANNEL SITES*/
  channelTypeMarketplace: 'OMN00109',
  channelTypeSite: 'OMN00110',
  channelTypeStore: 'OMN00111',

  /*OMNICHANNEL STORE*/
  seasonBoxAlwaysOnSale: 'OMN00112',
  pricelistBaseStore: 'OMN00117',
  generateLabelButton: 'OMN00141',
  okGenerateLabelButton: 'OMN00142',

  /* OMNICHANNEL EXPENSES */
  expensesColumnAlreadyExists: 'OMN00143',
  expensesAddNewColumn: 'OMN00144',

  /*Seasons*/
  seasonBoxSeasonRuleHead: 'OMN00001',
  seasonBoxAddSeasonRule: 'OMN00002',
  seasonBoxSalesPeriod: 'OMN00009',
  seasonBoxPopoverAddSeason: 'OMN00010',
  seasonBoxPopoverShowSeason: 'OMN00107',
  seasonBoxPopoverCopySeason: 'OMN00011',
  seasonBoxPopoverHideSeason: 'OMN00012',
  deleteMultiRulePopoverText: 'OMN00029',
  deleteSingleRulePopoverText: 'OMN00032',
  seasonBoxCarryOver: 'OMN00033',
  seasonBoxOutlet: 'OMN00034',
  seasonBoxPromo: 'OMN00072',
  seasonBoxFrom: 'OMN00073',
  seasonBoxTo: 'OMN00074',
  createEmptySeason: 'OMN00097',
  restoreSeason: 'OMN00098',

  /*Rule creation*/
  ruleBoxSetSeasonRule: 'OMN00003',
  ruleBoxaddSeasonRule: 'OMN00004',
  ruleBoxRuleName: 'OMN00005',
  ruleBoxSalesPeriod: 'OMN00006',
  ruleBoxStartDate: 'OMN00007',
  ruleBoxChannelSelection: 'OMN00008',
  ruleBoxPopoverSaveRule: 'OMN00013',
  ruleBoxPopoverDeleteRule: 'OMN00014',
  ruleBoxPopoverCopyRule: 'OMN00015',
  channelListOptionAllText: 'OMN00030',
  ruleBoxRuleNamePlaceholder: 'OMN00031',
  ruleBoxDecimalPricePlaceholder: 'OMN00116',
  subRuleBoxPopoverSubRuleDeleteRuleTitle: 'OMN00068',
  subRuleBoxPopoverSubRuleDeleteRule: 'OMN00069',
  ruleBoxInSeason: 'OMN00070',
  ruleBoxPromo: 'OMN00071',
  ruleBoxEndDate: 'OMN00075',
  ruleBoxMoveToOutlet: 'OMN00084',
  ruleBoxPopoverMoveToOutlet: 'OMN00085',
  newRuleNameStart: 'OMN00099',
  newRuleNameCopy: 'OMN00100',
  newSubruleNameStart: 'OMN00101',
  dateTimezoneLabel: 'OMN00103',
  ruleBoxEditing: 'OMN00108',

  /*SubRule creation*/
  subRuleBoxTitle: 'OMN00063',
  subRuleBoxSubRuleName: 'OMN00064',
  subRuleBoxSubRuleNamePlaceholder: 'OMN00065',
  subRuleViewAll: 'OMN00066',
  subRuleViewOnlyModified: 'OMN00067',

  /**Omnichannel logs */
  insertsLog: 'OMN00118',
  changesLog: 'OMN00119',
  deleteLog: 'OMN00120',
  detailedRules: 'OMN00129',
  applyFilter: 'OMN00130',
  clearFilter: 'OMN00131',
  transactionType: 'OMN00132',
  /**log table*/
  logTableDate: 'OMN00121',
  logTableName: 'OMN00122',
  logTableSeason: 'OMN00123',
  logTableField: 'OMN00124',
  logTableOldValue: 'OMN00125',
  logTableNewValue: 'OMN00126',
  logTableUser: 'OMN00127',
  logTableOperation: 'OMN00128',

  /*Warnings*/
  warningNoRuleToCopy: 'OMN00016',
  warningSeasonTextCharLength: 'OMN00022',
  warningSeasonDateAlreadyUsed: 'OMN00023',
  warningSeasonNameAlreadyTaken: 'OMN00024',
  warningRuleNoArticles: 'OMN00087',
  missSelectSeasonWarning: 'OMN00102',
  warningFailedSaveSeasonRule: 'OMN00106',
  warningNoData: 'OMN00115',
  checkArticlesInSeason: 'OMN00147',
  checkArticlesSuperGroup: 'OMN00148',
  checkArticlesBrand: 'OMN00149',
  checkPricelistChannelAssociation: 'OMN00150',
  /*Discount table*/
  discountGeneralDiscount: 'OMN00018',
  discountListHead: 'OMN00019',
  discountIconClear: 'OMN00104',
  discountClearMessage: 'OMN00105',

  /*Modal*/
  seasonModalCopySeasonTitle: 'OMN00020',
  seasonModalCopySeasonBody: 'OMN00021',
  confirmChangeModalTitle: 'OMN00025',
  confirmChangeModalBody: 'OMN00026',
  confirmChangeModalConfirm: 'OMN00027',
  confirmChangeModalCancel: 'OMN00028',

  /*Channel*/
  btnChannelsSetting: 'OMN00017',
  titleChannelsSetting: 'OMN00035',
  channelTableName: 'OMN00036',
  channelTableModifiedDate: 'OMN00037',
  channelTablePricelist: 'OMN00038',
  channelTableCommission: 'OMN00039',
  channelTableFixedImport: 'OMN00040',
  channelTableFixedShipping: 'OMN00041',
  channelRangeFromTo: 'OMN00042',
  channelTableSetRange: 'OMN00043',
  channelRangeOver: 'OMN00044',
  channelRangeAdd: 'OMN00076',
  channelRangeCommission: 'OMN00077',
  channelTableCommissions: 'OMN00078',
  dropdownChannelRuleMontlyFixedImport: 'OMN00079',
  titleChannelsPanel: 'OMN00086',
  btnCostsRegister: 'OMN00091',
  titleRegisterCosts: 'OMN00092',
  checkboxRangeChannelRange: 'OMN00093',
  checkboxSectorChannelRange: 'OMN00094',
  checkboxSupergroupChannelRange: 'OMN00095',
  channelTableRangeSet: 'OMN00096',
  backTextMultishippingModal: 'OMN00133',
  resetMultishippingExceptionsPopconfirmTitle: 'OMN00134',
  resetMultishippingExceptionsPopconfirmDescription: 'OMN00135',
  multishippingModalCode: 'OMN00136',
  multishippingModalNation: 'OMN00137',
  multishippingModalAmount: 'OMN00138',
  multishippingExceptionsSet: 'OMN00139',
  multishippingExceptionsAddException: 'OMN00140',
  /*Channels Outlet*/
  outletTitlePanel: 'OMN00080',
  outletSeasonInput: 'OMN00081',
  outletSeasonTitle: 'OMN00082',
  outletSelectAll: 'OMN00083',

  /*Popover*/
  listingPopTitle: 'OMN00045',
  listingPopListingTitle: 'OMN00046',
  listingPopListingType: 'OMN00047',
  listingPopListingVat: 'OMN00048',
  listingPopListingSell: 'OMN00049',
  listingPopListingBuy: 'OMN00050',
  listingPopListingVatYes: 'OMN00051',
  listingPopListingVatNo: 'OMN00052',
  listingPopListingB2C: 'OMN00053',
  listingPopCopyDiscountValue: 'OMN00088',
  listingPopApply: 'OMN00089',
  listingPopCancel: 'OMN00090',
  listingPopListingTitleSite: 'OMN00113',
  listingPopListingTitleStore: 'OMN00114',

  /*Sub Rule Table*/
  tableSubRulePurchased: 'OMN00054',
  tableSubRuleStockDays: 'OMN00055',
  tableSubRuleSellout: 'OMN00056',
  tableSubRulePercSellOut: 'OMN00153',
  tableSubRuleExisting: 'OMN00057',
  tableSubRuleExistingPrice: 'OMN00058',
  tableSubRuleDeliveredPerc: 'OMN00059',
  tableSubRuleListingPurchased: 'OMN00060',
  tableSubRuleListingDiscount: 'OMN00061',
  tableSubRuleListingMargin: 'OMN00062',
  importExcelNotify: 'OMN00145',
  importExcelNotifyClick: 'OMN00146',

  /*SETTINGS*/
  settingsTitle: 'STG00001',
  priceAndDiscountSettings: 'STG00002',
  addGallery: 'STG00005',
  deleteGalleryConfirmMessage: 'STG00006',
  enablePricelistSetting: 'STG00014',
  disablePricelistSetting: 'STG00015',
  siteTableName: 'STG00016',
  siteTablePricelists: 'STG00017',
  siteTableEnabled: 'STG00018',
  storeTableName: 'STG00049',
  storeTablePricelist: 'STG00050',
  storeTableSalesStartDate: 'STG00051',
  storeTableSalesEndDate: 'STG00052',

  deleteColumnPopoverText: 'STG00019',
  warningRespondingEntityNameUsed: 'STG00020',
  columnHeaderEdit: 'STG00021',
  columnHeaderDelete: 'STG00022',
  columnHeaderAdd: 'STG00023',
  columnHeaderAll: 'STG00024',
  checkboxAllOnMultianswer: 'STG00024',
  editColumnPopoverText: 'STG00025',
  checkboxEmptyOnMultianswer: 'STG00026',
  emptyOnSingleanswer: 'STG00032',
  addColumnPopoverText: 'STG00027',
  changePriorityOption: 'STG00028',
  changePriorityModalTitle: 'STG00029',
  changePrioritySave: 'STG00030',
  changePriorityCancel: 'STG00031',

  /*PIM*/
  //IMAGES SECTION
  buttonImages: 'PIM00001',
  imagesSection: 'PIM00002',
  photoBox: 'PIM00003',
  gallerySettings: 'PIM00004',
  photoMenuEdit: 'PIM00005',
  photoMenuDelete: 'PIM00006',
  pimImageTypeMain: 'PIM00007',
  pimImageTypeDetail: 'PIM00008',
  pimImageTypeDraw: 'PIM00009',
  pimImageTypeMarketplace: 'PIM00010',
  photoMenuDeleteConfirm: 'PIM00011',
  photoMenuDeleteMessage: 'PIM00012',
}
